import React from "react"

const Bold = ({ children }) => {
  return <span className="font-weight-bold">{children}</span>
}

export default Bold
